<template>
    <div class="home" v-bind:style="{color: colors.foreground, backgroundColor: colors.background}">
        <Header HeaderTitle="Question List" />
        <Questions v-bind:questions="questions" v-on:del-question="deleteQuestion" v-bind:style="{color: colors.foreground, backgroundColor: colors.background}"/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Questions from '../components/Questions';
    import Header from '../components/layout/Header';
    import axios from 'axios';

    export default {
        name: 'home',
        components: {
            Header,
            Questions
        },
        methods: {
            setColors(mode) {
                return (mode == "bg") ? this.$route.params.bg : this.$route.params.fg;
            },
            deleteQuestion(id) {
                axios.get(`https://api.itslit.uk/Questions/read/${id}`)
                    .then(this.questions = this.questions.filter(question => question.qid !== id));
            },

            getQuestions() {
                axios.get(`https://api.itslit.uk/Questions/showlist/` + this.$route.params.streamer)
                .then(res => this.questions = res.data.response);
            }
        },
        created() {
            this.getQuestions();

            setInterval(function () {
                this.getQuestions();
            }.bind(this), 10000); 
        },
        data() {
            return {
                questions: [],
                colors: {
                    background: this.setColors("bg"),
                    foreground: this.setColors("fg")
                }
            }
        }
    }
</script>

<style scoped>
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: Arial, Helvetica, sans-serif;
        line-height: 1.4;
    }
</style>
